import { Badge } from "@/components/ui/badge"
import type { HttpMethod } from "@/types/endpoint"

// Plain neutral chip for HTTP methods. Color-coding is more visual noise
// than help in a dense list — keep all methods the same tone.
export function HttpMethodBadge({ method }: { method: HttpMethod }) {
  return <Badge tone="neutral">{method}</Badge>
}
